import { render, staticRenderFns } from "./SimpleRegistrationForm.vue?vue&type=template&id=5402b0ef&"
import script from "./SimpleRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./SimpleRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRegistrationForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports